import {Log} from '@aboutyou/mlm';
import {useIsLoggedIn} from '@aboutyou/user';
import {useCallback} from 'react';
import {useCreateSnapshotCampaign} from '../../Campaigns/SelectedDiscounts/useSelectedDiscount';
import {useCampaignKeyCallback} from '../../Campaigns/campaign-state/campaign.hooks';

export const usePrepareCheckout = () => {
  const getCampaignKey = useCampaignKeyCallback();
  const createCampaignKeySnapshot = useCreateSnapshotCampaign();
  const isLoggedIn = useIsLoggedIn();

  return useCallback(async () => {
    const campaignKey = await getCampaignKey();
    createCampaignKeySnapshot({
      campaignKey: campaignKey ?? null,
    });

    Log.unSampledLog('PrepareCheckoutDiscountEvent', {
      isLoggedIn,
      checkoutDiscountKey: campaignKey,
    });
  }, [getCampaignKey, isLoggedIn, createCampaignKeySnapshot]);
};
